import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children, isAdmin, superAdminOnly, permission, action = 'view' }) => {

    const { loading, isAuthenticated, user } = useSelector(state => state.user);

    if (loading !== false) return null;

    if (isAuthenticated === false) return <Navigate to="/login" />;

    if (isAdmin) {
        const isSuperAdmin = user.role === "admin";
        const isStaff = user.role === "staff";

        if (!isSuperAdmin && !isStaff) return <Navigate to="/login" />;

        if (superAdminOnly && !isSuperAdmin) return <Navigate to="/admin/dashboard" />;

        if (!isSuperAdmin && permission) {
            const staffPermissions = user.adminRole?.permissions || {};
            if (!staffPermissions[permission]?.[action]) return <Navigate to="/admin/dashboard" />;
        }
    }

    return children;
};

export default ProtectedRoute;